import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "@store/store";

type locationPermission = "pending" | "denied" | "inUse" | "always";
interface CurrentLocation {
  updatedAt: string;
  coordinates: { latitude: number; longitude: number };
}

export interface LocationReducerState {
  permission: locationPermission;
  currentLocation?: CurrentLocation;
}

const initialState: LocationReducerState = {
  permission: "pending",
  currentLocation: undefined,
};

export const locationSlice = createSlice({
  name: "location",
  initialState,
  reducers: {
    setLocationPermissionAction: (
      state: LocationReducerState,
      action: PayloadAction<{ permission: locationPermission }>,
    ) => {
      state.permission = action.payload.permission;
    },
    setCurrentLocationAction: (
      state: LocationReducerState,
      action: PayloadAction<CurrentLocation>,
    ) => {
      state.currentLocation = action.payload;
    },
  },
});

export const selectUserLocation = (state: RootState) => {
  return state.location.currentLocation;
};

export const { setLocationPermissionAction, setCurrentLocationAction } =
  locationSlice.actions;

// eslint-disable-next-line import/no-default-export
export default locationSlice.reducer;
